/**
 * TanStack Query key factory for the Analytics domain.
 * Enforces strict scope separation:
 * - Tenant-scoped keys for authenticated campaign analytics (`orgId`, `campaignId`)
 * - Token-scoped keys for public shared analytics (`token`)
 */
export const analyticsKeys = {
  all: ['analytics'] as const,

  // Tenant / Campaign Scoped Queries
  campaign: (campaignId: string) => [...analyticsKeys.all, 'campaign', campaignId] as const,
  deliverableAggregates: (campaignId: string) =>
    [...analyticsKeys.campaign(campaignId), 'deliverableAggregates'] as const,
  performanceTimeSeries: (campaignId: string) =>
    [...analyticsKeys.campaign(campaignId), 'performanceTimeSeries'] as const,
  platformDistribution: (campaignId: string) =>
    [...analyticsKeys.campaign(campaignId), 'platformDistribution'] as const,
  budgetCalculations: (campaignId: string) =>
    [...analyticsKeys.campaign(campaignId), 'budgetCalculations'] as const,
  topPosts: (campaignId: string) =>
    [...analyticsKeys.campaign(campaignId), 'topPosts'] as const,
  shareLink: (campaignId: string) =>
    ['campaign-share-link', campaignId] as const,

  // Public / Token Scoped Queries (Unauthenticated)
  public: {
    all: ['public-analytics'] as const,
    byToken: (token: string) => [...analyticsKeys.public.all, token] as const,
    metadata: (token: string) => [...analyticsKeys.public.byToken(token), 'metadata'] as const,
    branding: (token: string) => [...analyticsKeys.public.byToken(token), 'branding'] as const,
    timeSeries: (token: string) => [...analyticsKeys.public.byToken(token), 'timeSeries'] as const,
    summary: (token: string) => [...analyticsKeys.public.byToken(token), 'summary'] as const,
    aggregates: (token: string) => [...analyticsKeys.public.byToken(token), 'aggregates'] as const,
    platformDistribution: (token: string) =>
      [...analyticsKeys.public.byToken(token), 'platformDistribution'] as const,
    topPosts: (token: string) => [...analyticsKeys.public.byToken(token), 'topPosts'] as const,
    brand: (campaignId: string) => [...analyticsKeys.public.all, 'brand', campaignId] as const,
    organization: (id: string) => [...analyticsKeys.public.all, 'organization', id] as const,
  },
};
